import { createStyles } from '@mantine/styles';


export default createStyles((theme: {
    colors: { [x: string]: any[] };
    white: string;
    fontSizes: any;
    spacing: any;
    radius: any;
    fn: any;
    shadows: any;
    colorScheme: any;
}) => ({

    modalWrapper: {
        '.mantine-Modal-header': {
            marginRight: 0,
        },

        '.mantine-Modal-title': {
            marginRight: 0,
            width: '100%',
            textAlign: 'center',
        },
    },

    modalButtons: {
        fontWeight: 400,
    },

}));
